/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { PB_URL } from '../lib/config.js';
import { playPop } from '../lib/sound.js';
import * as store from '../lib/store.js';

export default {
  openInbox() { return this.setState({ dialog: 'inbox', reqError: '', notifOpen: false }, this.fetchRequests); },

  // Elk stukje nieuws brengt je ergens: naar een profiel, een krabbel of je postvakje.
  notifGoProfile(id) {
      if (!id) return;
      this.setState({ notifOpen: false, dialog: 'account', profileId: id, accountError: '' });
    },

  notifGoDrawing(id) {
      if (!id) return;
      this.setState({ notifOpen: false, dialog: null, profileId: null }, () => this.openViewer(id));
    },

  async fetchRequests() {
      this.setState({ reqLoading: true });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_requests/records?sort=-created&perPage=100`);
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const all = (data.items || []).map((r) => ({
          id: r.id, fromId: r.fromId || '', toId: r.toId || '', text: r.text || '',
          status: r.status || 'open', drawingId: r.drawingId || '', doneBy: r.doneBy || '', created: r.created || ''
        }));
        // Voltooide verzoekjes verdwijnen na een dag uit het postvakje, maar blijven
        // wel bestaan: het labeltje op de krabbel zelf hoort te blijven staan.
        const cutoff = Date.now() - 86400000;
        const items = all.map((r) => {
          if (r.status !== 'done' || !r.created) return r;
          const t = new Date(r.created).getTime();
          return !isNaN(t) && t < cutoff ? { ...r, archived: true } : r;
        });
        this.setState({ reqList: items, reqLoading: false });
        this.checkRequestDone(items);
      } catch (e) {
        this.setState({ reqLoading: false });
      }
    },

  checkRequestDone(items) {
      const me = this.state.accountId;
      if (!me) return;
      const mine = items.filter((r) => r.status === 'done' && r.fromId === me).map((r) => r.id);
      let seen = null;
      try { seen = JSON.parse(store.get('gp_req_done_seen') || 'null'); } catch (e) {}
      if (!Array.isArray(seen)) {
        store.set('gp_req_done_seen', JSON.stringify(mine));
        return;
      }
      const fresh = mine.filter((id) => seen.indexOf(id) < 0);
      if (!fresh.length) return;
      store.set('gp_req_done_seen', JSON.stringify(seen.concat(fresh)));
      const r0 = items.find((r) => r.id === fresh[0]);
      const who = r0 && r0.doneBy ? (this.state.accounts || []).find((a) => a.id === r0.doneBy) : null;
      this.setState({ notifUnseen: true });
      this.notify((who ? who.name : 'Iemand') + ' heeft jouw verzoekje getekend!');
      playPop();
    },

  async setRequestStatus(id, status) {
      this.setState((st) => ({ reqList: (st.reqList || []).map((r) => (r.id === id ? { ...r, status } : r)) }));
      try {
        await api(`${PB_URL}/api/collections/paal_requests/records/${id}`, asJson('PATCH', { status }));
      } catch (e) {}
    },

  onReqInput(e) { return this.setState({ reqText: e.target.value }); },

  async submitRequest() {
      const text = (this.state.reqText || '').trim();
      if (!this.state.accountId) { this.setState({ reqError: 'Kies eerst je eigen account.' }); return; }
      if (!text) { this.setState({ reqError: 'Schrijf eerst je verzoekje.' }); return; }
      if (!this.state.reqTo) { this.setState({ reqError: 'Kies aan wie je het verzoekje stuurt.' }); return; }
      this.setState({ reqSending: true, reqError: '' });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_requests/records`, asJson('POST', { fromId: this.state.accountId, toId: this.state.reqTo || '', text, status: 'open', drawingId: '' }));
        if (!res.ok) throw new Error(res.status === 404 ? 'missing' : String(res.status));
        const toName = (this.state.accounts.find((a) => a.id === this.state.reqTo) || {}).name || 'Die persoon';
        this.setState({ reqSending: false, reqText: '', reqTo: '', reqSentTo: toName }, this.fetchRequests);
        playPop();
      } catch (e) {
        this.setState({
          reqSending: false,
          reqError: e.message === 'missing'
            ? 'Maak op de server de collectie paal_requests aan met velden fromId, toId, text, status, drawingId (tekst).'
            : 'Versturen mislukt. Probeer het nog eens.'
        });
      }
    },

  takeRequest(req) {
      // Aannemen betekent naar het tekenscherm, en dat bestaat op een telefoon niet.
      // Dan is weigeren met een uitleg beter dan iemand in een scherm zetten waar
      // hij meteen weer uit gegooid wordt.
      if (this.state.isMobile) {
        this.notify('Dit verzoekje pak je op een computer op; daar kun je tekenen.');
        return;
      }
      // Zie openStudio: eerst vastleggen wat er op een doek staat dat al open is.
      if (this.state.studioOpen) this.snapshotCanvas();
      this.vensterNaarVoren('studio');
      this.setState({ activeRequest: req, dialog: null, chatOpen: false, notifOpen: false, studioOpen: true, studioMin: false, publishTitle: '' }, () => {
        this.needsRestore = true;
        this.computeCanvasSize();
      });
    },

  // Opnieuw uitrekenen: zonder verzoekje hoeft de strook onder het doek minder ruimte.
  clearActiveRequest() { return this.setState({ activeRequest: null }, this.computeCanvasSize); },

  async closeRequest(drawingId) {
      const req = this.state.activeRequest;
      if (!req) return;
      this.setState({ activeRequest: null }, this.computeCanvasSize);
      try {
        await api(`${PB_URL}/api/collections/paal_requests/records/${req.id}`, asJson('PATCH', { status: 'done', drawingId: drawingId || '', doneBy: this.state.accountId || '' }));
      } catch (e) {}
    }
};
